import { render } from "./PopupViewCertificate.vue?vue&type=template&id=403f72b7"
import script from "./PopupViewCertificate.vue?vue&type=script&lang=js"
export * from "./PopupViewCertificate.vue?vue&type=script&lang=js"

import "./PopupViewCertificate.vue?vue&type=style&index=0&id=403f72b7&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__